import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import roles from "../features/admin/role_permmission/role/Slice";
import Owner from "../features/admin/role_permmission/owner/Slice";
import upgrade_role from "../features/admin/role_permmission/upgrade_role/Slice";

const customers = combineReducers({
  roles: roles,
  Owner: Owner,
  upgrade_role: upgrade_role,
});

export default customers;
